var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 91,
    viewBox: "0 0 96 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 94,
    height: 59,
    stroke: "#7ABB5C",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95 1L95 91",
    stroke: "#BB785C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1L0.999997 61",
    stroke: "#1896DC",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.0737 21.6667L73.921 21L72.4181 21.3442L72.6234 22.2408L62.0078 72.6652L63.5166 72.9828L73.4443 25.8256L83.982 71.8397L85.4849 71.4955L74.202 22.2268L74.3094 21.7164L74.0737 21.6667Z",
    fill: "#7ABB5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.4964 46.3796L92.8418 46.2817L92.6718 45.6819L92.8195 45.0941L92.4811 45.009L92.4213 44.7983L92.0554 44.902L57.5539 36.2285L57.178 37.7238L89.0829 45.7446L55.9994 55.1221L56.4199 56.6055L92.0793 46.4978L92.4436 46.5894L92.4964 46.3796Z",
    fill: "#7ABB5C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55 0L55 91",
    stroke: "#7ABB5C",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54 90L96 90",
    stroke: "#BB5CA0",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96 1L-2.86102e-06 1",
    stroke: "#E9B80A",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBody);
export default __webpack_public_path__ + "static/media/body.5e91f6b1e15bc89fd25ed423c56d13cf.svg";
export { ForwardRef as ReactComponent };